<template>
  <div>
    <p class="minimal-bold-black">
      {{ brandName }}
    </p>
    <p class="minimal-bold-black">
      {{ itemName }}
    </p>
    <p v-if="showItemSkuName" class="minimal-bold-black">
      {{ itemSkuName }}
    </p>
    <p class="minimal-black">
      {{ `¥${price.toLocaleString()}`
      }}<span v-if="isIncludingTax">（税込）</span>
    </p>
    <p class="minimal-black">
      {{ `数量：${quantity.toLocaleString()}枚` }}
    </p>
    <p class="minimal-black">
      {{ `引渡/提供時期：${dateOfDeliveryNote}` }}
    </p>
    <p v-if="showLimitedTime" class="minimal-black">
      {{ `申込期間：${formattedLimitedEndDateTime}までの期間限定販売` }}
    </p>
    <p v-else class="minimal-black">
      申込期間：期限制限無し
    </p>
  </div>
</template>

<script setup>
import dayjs from 'dayjs'
import { computed } from 'vue'

const TICKET_TYPES = {
  gajoen: {
    key: 'gajoen',
    dateOfDeliveryNote:
      '電子チケットについては、入金確認後3営業日以内に発行いたします。'
  },
  storeAdmin: {
    key: 'storeAdmin',
    dateOfDeliveryNote:
      '電子チケットについては、入金確認後3営業日以内に発行いたします。' +
      '商品の配送は各ブランドの責任により行いますが、受取人様において' +
      '発送先住所入力をいただいてから7日以内を目安にブランド側にて発送いたします。'
  },
  sbj: {
    key: 'sbj',
    dateOfDeliveryNote:
      '電子チケットについては、入金確認後3営業日以内に発行いたします。'
  },
  gifteeBox: {
    key: 'gifteeBox',
    dateOfDeliveryNote:
      '電子チケットについては、入金確認後3営業日以内に発行いたします。'
  },
  heathrow: {
    key: 'heathrow',
    dateOfDeliveryNote:
      '電子チケットについては、入金確認後3営業日以内に発行いたします。' +
      '商品の配送は各ブランドの責任により行いますが、受取人様において発送先住所入力をいただいてから7日以内、' +
      'または配送日指定が可能な場合はその日時を目安にブランド側にて発送いたします。'
  }
}

const props = defineProps({
  brandName: {
    type: String,
    required: true
  },
  itemName: {
    type: String,
    required: true
  },
  itemSkuName: {
    type: String,
    required: false,
    default: ''
  },
  price: {
    type: Number,
    required: true
  },
  quantity: {
    type: Number,
    required: true
  },
  limitedEndDateTime: {
    type: [Date, null],
    required: false,
    default: null
  },
  ticketType: {
    type: String,
    required: true
  },
  isIncludingTax: {
    type: Boolean,
    required: true
  }
})

const showLimitedTime = computed(() => props.limitedEndDateTime !== null)
const showItemSkuName = computed(() => props.itemSkuName !== '')
const formattedLimitedEndDateTime = computed(() =>
  dayjs(props.limitedEndDateTime).format('YYYY年M月D日 HH:mm')
)
const dateOfDeliveryNote = computed(
  () => TICKET_TYPES[props.ticketType]?.dateOfDeliveryNote
)
</script>
